import React from "react";
import { connect } from "react-redux";
import UnshippedWorkWidget, {
  SALES_COLUMNS_NO_SHIPMENT,
} from "./UnshippedWorkWidget";

// "Non Shipped Labor" — labor lines still outstanding, for installation managers
// who need to know what labor is waiting to be entered.
//
// The exact complement of Unshipped Jobs: orders are included only when they have
// an outstanding line whose BC item-card reservation policy *is* "Never" — the
// service items (Hourly Labor, installation, demo, trip charges).
//
// There is no Warehouse Shipments section and no Shipment No. column: labor is
// never loaded onto a truck, so neither carries meaning here.
const NonShippedLabor = ({ auth: { auth } }) => (
  <UnshippedWorkWidget
    token={auth && auth[0] ? auth[0].token : null}
    endpoint="NonShippedLabor"
    title="Non Shipped Labor"
    icon="🔧"
    salesColumns={SALES_COLUMNS_NO_SHIPMENT}
    salesSectionTitle="Sales Orders — Labor Not Entered"
    showShipments={false}
  />
);

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(NonShippedLabor);
